//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IndexHeader from '@/components/IndexHeader'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'

export default {
  name: 'index',
  data () {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }
      ]
    }
  },
  methods: {},
  components: {
    IndexHeader,
    IndexSidebar,
    IndexFooter
  }
}



// WEBPACK FOOTER //
// ./src/pages/solution/microBussiness/index.vue